<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="运营商:" :label-width="65">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
					<!-- <span slot="prepend">联系电话</span> -->
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="充电站" :label-width="65">
				<Select filterable placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.ConnectorNo" placeholder="充电枪编号" style="width: 180px;">
				<span slot="prepend">充电枪编号</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.EquipmentSerialNo" placeholder="设备序列号" style="width: 180px;">
				<span slot="prepend">设备序列号</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName" label="告警类型" :label-width="70">
				<Select filterable placeholder="告警类型" style="width: 120px;" v-model="formInline.AlarmCode">
					<Option :value="-1">全部</Option>
					<Option v-bind:key="item.Id" v-for="(item) in AlarmDefineList" :value="item.Id">{{item.Name}}</Option>
				</Select>
			</FormItem>
			<!-- <FormItem label="开始时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="开始时间"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem label="结束时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="结束时间"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
		</Form>
		<!-- <Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getAlarmRecordUrl" @listData='getDeviceData'>
			</MyPage>
		</Table> -->
		<PageTable ref="table" :columns="columns1" :tableHeight="tableHeight" :url="getAlarmRecordUrl" :queryParam="pageParam"></PageTable>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import PageTable from '../../public/PageTable/PageTable.vue';
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			PageTable
		},
		data() {
			return {
				getAlarmRecordUrl: webapi.base_api_url + '/Maintenance/GetAlarmRecord',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['运维管理', '>>', '告警记录'],
				AlarmDefineList: [],
				formInline: {
					StationId: 0,
					ConnectorNo: '',
					EquipmentSerailNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
				},
				//table标题数据
				columns1: [{
						title: '序号',
						type: 'index',
						width: 80
					},
					{
						title: '发生时间',
						key: 'OccurredTime',
						minWidth: 180,
					}, {
						title: '告警代码',
						key: '',
						render: (h, params) => h('div', params.row.AlarmCode + '-' + params.row.AlarmDesc)
					},
					{
						title: '告警等级',
						key: 'AlarmLevel',
						render: (h, params) => h('div', params.row.AlarmLevel == 1 ? '1-人身安全级' : params.row.AlarmLevel == 2 ?
							'2-设备安全级' : '3-告警提示级'),
					},
					// {
					// 	title: '告警详情',
					// 	key: 'AlarmDesc'
					// },
					{
						title: '告警状态',
						key: 'Status',
						render:(h,params)=>  h('div',params.row.Status + '-' + params.row.StatusDesc),
					},
					// {
					// 	title: '告警状态描述',
					// 	key: 'StatusDesc'
					// },
					{
						title: '充电枪编码',
						key: 'ConnectorNo'
					},
					{
						title: '充电桩编码',
						key: 'EquipmentNo'
					},
					{
						title: '设备序列号',
						key: 'EquipmentSerialNo'
					},
					{
						title: '充电站名称',
						key: 'StationName'
					},
					// {
					// 	title: '备注',
					// 	key: 'Remark'
					// }
				],
				data1: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
			this.getAlarmDefineList();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatorList: 'typeList',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			//操作
			show: function(type, params) {},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.table.getData();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1552 ? 40 : 0);
			},
			getAlarmDefineList: function() {
				this.axios.post(webapi.base_api_url + '/Common/GetAlarmDefineList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.AlarmDefineList = res.data.Data.List;
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>